// extracted by mini-css-extract-plugin
export default {"pageSize":"pageSize_pageSize__RFFiDrUG"};